import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';
import CodePlayground from '../CodePlayground';
import "./CSS/CodeEditor.css"
import QuestionPrompt from './QuestionPrompt';
import { useState, useEffect, useContext } from 'react';
import { baseURL } from '../Config/settings';
import Navbar from './Navbar';

import { userContext } from '../App';

const CodeEditor = () => {
    const { id } = useParams()
    const [problem, setProblem] = useState(null)
    const [old, setOld] = useState(null)
    const [output, setOutput] = useState('Output is displayed Here')
    const [code, setCode] = useState("")
    const rightHalfRef = useRef(null)

    // const [loading, setLoading] = useState({preset: true, solution: true})

    const {user, setUser} = useContext(userContext)

    useEffect(() => {
        fetch(`${baseURL}/problems/${id}`)
        .then(response => response.json())
        .then(question => setProblem(question))

        if(user !== null) {
            fetch(`${baseURL}/problems/old/`, {
            method: "POST",
            headers: {
                'Content-Type': "application/json"
            },
            body: JSON.stringify({
                "email": user.email,
                "id": id
            })
        })
        .then(response => response.json())
        .then(data => {
            setOld(data.solution)
        })
        }
    }, [id, user])

    useEffect(() => {
        if(old !== null) {
            setCode(old)
        }
        else if(problem !== null) {
            setCode(problem.start_code)
        }
    }, [problem, old])

    const handlePresetCode = () => {
        setCode(problem.start_code)
    }

    return (
        <>
        <Navbar></Navbar>
        <div className='editor-page'>
            {problem === null ? <p>Loading</p>: <QuestionPrompt rightHalfRef={rightHalfRef} output={output} problem={problem}></QuestionPrompt>}
            {problem === null ? <p>Loading</p>: <CodePlayground rightHalfRef={rightHalfRef} setOutput={setOutput} presetCode={problem.start_code} userCode={old} code={code} setCode={handlePresetCode}></CodePlayground>}
        </div>
        </>
    )
};

export default CodeEditor;
